<template>
    <v-card flat>
      <v-card-text>
        <v-row>
          <v-text-field
            v-model="address"
            :label="$t('contacts.columns.street')"
          ></v-text-field>
        </v-row>
        <v-row>
          <v-select
            v-model="addressType"
            :items="addressTypes"
            :item-text="(addrType) => (addrType)['display']"
            :item-value="(addrType) => (addrType)['key']"
            :return-object="false"
            :label="$t('contacts.columns.addressType')"
            clearable
          >
          </v-select>
        </v-row>
        <v-row>
          <v-text-field
            v-model="city"
            :label="$t('contacts.columns.city')"
          ></v-text-field>
        </v-row>
        <v-row>
          <v-text-field
            v-model="postalCode"
            :label="$t('contacts.columns.postalCode')"
          ></v-text-field>
        </v-row>
        <v-row>
          <v-country-select v-model="country" :country="country" :countryName="true" :label="$t('contacts.columns.country')" :usei18n="false" /> <!-- no i18n since we don't have the list of countries translated. -->
          <!-- this a cool and magic region dropdown based on the selected country but wont display region if set from mgm as mgm save it manually and so name dont match -->
          <!-- <v-region-select v-model="region" :value="region" :autocomplete="true" :country="country" :region="region" :regionName="true" :countryName="true" :label="$t('contacts.columns.state')" /> -->
        </v-row>
        <v-row>
          <v-text-field
            v-model="region"
            :label="$t('contacts.columns.state')"
          ></v-text-field>
        </v-row>
      </v-card-text>
    </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'contacts-form-fields-companyTab',
  data () {
    return {
      defaultCountry: 'CA',
      addressTypes: [
        {
          key: 'home',
          display: this.$t('contacts.form.addressTypes.home')
        },
        {
          key: 'work',
          display: this.$t('contacts.form.addressTypes.work')
        },
        {
          key: 'school',
          display: this.$t('contacts.form.addressTypes.school')
        },
        {
          key: 'other',
          display: this.$t('contacts.form.addressTypes.other')
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      contact: 'contacts/form/contact'
    }),
    addressType: { get () { return this.contact?.addressType }, set (addressType) { this.setAddressType(addressType) } },
    address: { get () { return this.contact?.street }, set (street) { this.setStreet(street) } },
    city: { get () { return this.contact?.city }, set (city) { this.setCity(city) } },
    region: { get () { return this.contact?.state }, set (region) { this.setRegion(region) } },
    postalCode: { get () { return this.contact?.postalCode }, set (postalCode) { this.setPostalCode(postalCode) } },
    country: { get () { return this.contact?.country }, set (country) { this.setCountry(country) } }
  },
  methods: {
    ...mapActions({
      setAddressType: 'contacts/form/setAddressType',
      setStreet: 'contacts/form/setStreet',
      setCity: 'contacts/form/setCity',
      setRegion: 'contacts/form/setRegion',
      setPostalCode: 'contacts/form/setPostalCode',
      setCountry: 'contacts/form/setCountry'
    })
  }
}
</script>

<style>

</style>
